var _notificationBoxCSS, _notificationIconCSS;

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 0.5rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  padding-right: 3rem;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 1rem;\n  height: ", ";\n  width: ", ";\n  flex: 0 0 ", ";\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    background-image: url(", ");\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    background-image: url(", ");\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 0.75rem;\n  padding: 0.75rem 1rem;\n  border-radius: 0.1875rem;\n  box-shadow: 0 0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.22), 0 0 0.0625rem 0 rgba(0, 0, 0, 0.32);\n\n  .notification__ok-button {\n    min-width: unset;\n  }\n  pointer-events: all;\n  transition: opacity 1000ms ease-out;\n  ", ";\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n\n    .notification__ok-button .button__text-wrapper {\n      color: ", ";\n      text-transform: uppercase;\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n\n    .notification__ok-button .button__text-wrapper {\n      color: ", ";\n      text-transform: uppercase;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  margin: 0 auto;\n  bottom: 1.5rem;\n  left: 50%;\n  width: 100%;\n  max-width: 50%;\n  transform: translateX(-50%);\n  pointer-events: none;\n  ", " {\n    max-width: 80%;\n  }\n  ", " {\n    max-width: 90%;\n  }\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { NotificationTypes } from "../../notificationsContext/NotificationsContext.types";
import styled, { css, to } from "../../../../theme";
import check from "../../../../assets/icons/check-circled.svg";
import error from "../../../../assets/icons/exclamation-circled.svg";
export var NotificationsBox = styled.div(_templateObject(), to('lg'), to('md'));
var notificationBoxCSS = (_notificationBoxCSS = {}, _defineProperty(_notificationBoxCSS, NotificationTypes.SUCCESS, css(_templateObject2(), function (props) {
  return props.theme.variables.colors.green;
}, function (props) {
  return props.theme.variables.colors.white;
})), _defineProperty(_notificationBoxCSS, NotificationTypes.ERROR, css(_templateObject3(), function (props) {
  return props.theme.variables.colors.midRed;
}, function (props) {
  return props.theme.variables.colors.white;
})), _notificationBoxCSS);

var getNotificationBoxCSS = function getNotificationBoxCSS() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NotificationTypes.SUCCESS;
  return notificationBoxCSS[type];
};

export var NotificationBox = styled.div(_templateObject4(), function (props) {
  return props.fading ? 'opacity: 0' : 'opacity: 1';
}, function (props) {
  return getNotificationBoxCSS(props.type);
});
export var NotificationInfoRow = styled.div(_templateObject5(), function (props) {
  return props.theme.variables.colors.white;
}, function (props) {
  return props.theme.variables.fonts.size.smaller0;
}, function (props) {
  return props.theme.variables.fonts.weight.light;
});
var notificationIconCSS = (_notificationIconCSS = {}, _defineProperty(_notificationIconCSS, NotificationTypes.SUCCESS, css(_templateObject6(), check)), _defineProperty(_notificationIconCSS, NotificationTypes.ERROR, css(_templateObject7(), error)), _notificationIconCSS);

var getNotificationIconCSS = function getNotificationIconCSS() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NotificationTypes.SUCCESS;
  return notificationIconCSS[type];
};

export var NotificationIcon = styled.div(_templateObject8(), function (props) {
  return props.theme.variables.icons.size.large;
}, function (props) {
  return props.theme.variables.icons.size.large;
}, function (props) {
  return props.theme.variables.icons.size.large;
}, function (props) {
  return getNotificationIconCSS(props.type);
});
export var NotificationMessage = styled.div(_templateObject9());
export var NotificationActionRow = styled.div(_templateObject10());